import React, { useEffect, } from 'react';
import { connect, } from 'react-redux';
import { isEmpty } from 'ramda';
import { useHistory } from 'react-router-dom';
import Box from '@material-ui/core/Box';

import SummarySellerPanel from './components/SellerPanel';
import SummaryBuyerPanel from './components/BuyerPanel';
import SummaryOrderPanel from './components/OrderPanel';
import { checkoutTermsOperations, } from 'store/ducks/checkoutTerms';
import SummaryEmailClientPanel from './components/EmailClientPanel';
import SummaryNotesPanel from './components/NotesPanel';
import { routes } from '../../common/routes';

type Props = {
    fetchCheckoutTerms: Function,
    isCheckoutFormEmpty: boolean,
};

const Summary: React.FC<Props> = ({ fetchCheckoutTerms, isCheckoutFormEmpty, }) => {
    const history = useHistory();

    useEffect(
        () => {
            isCheckoutFormEmpty && history.replace(routes.CART);
            return;
        },
        [ history, isCheckoutFormEmpty, ]
    );

    useEffect(() => {
        fetchCheckoutTerms();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (isCheckoutFormEmpty) {
        return  null;
    }

    return (
        <Box margin="2rem 0">
            <SummarySellerPanel />
            <SummaryBuyerPanel />
            <SummaryEmailClientPanel />
            <SummaryNotesPanel />
            <SummaryOrderPanel />
        </Box>
    );
};

type MappingType = {
    checkout: {
        values: any,
    }
};

const mapStateToProps = ({ checkout: { values } }: MappingType) => ({ isCheckoutFormEmpty: isEmpty(values), });

const mapDispatchToProps = {
    fetchCheckoutTerms: checkoutTermsOperations.request,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Summary);
